import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/doctor"

export const List = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/list`, values);
}

export const Add = async (values) => {
    return await axiosInstance(options).post(`${path}/add`, values);
}

export const Edit = async (values, role) => {
    return await axiosInstance(role ? { role } : options).put(`${path}/edit`, values);
}

export const Delete = async (values) => {
    return await axiosInstance(options).delete(`${path}/delete?o_id=${values[0]}`, values)
}

export const changepassword = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-password`, values);
}

export const Details = async (id, role) => {
    return await axiosInstance(role ? { role } : options).get(`${path}/details?o_id=${id}`);
}

export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values)
}

export const allDoctors = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/get-all-doctors`, values);
}


export const listSchedule = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/list-schedule`, values);
}
export const addSchedule = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/add-schedule`, values);
}
export const editSchedule = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/update-schedule`, values);
}
export const detailSchedule = async (values, role) => {
    return await axiosInstance(role ? { role } : options).post(`${path}/get-schedule`, values);
}

